export enum SessionStorageKeys {
  FunnelForm = "FunnelForm",
  ExistingServiceByLicensePlate = "ExistingServiceByLicensePlate"
}